import * as React from 'react';

import { localeData } from '../../../locales/data';
import '../AlphasDetails/AlphasDetails.scss';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';
import { useDispatch } from 'react-redux';
import { setAlphaTestPeriodShown } from '../../../actions/AlphasActions';
import analytics from '../../../shared/services/analytics/analytics';

interface FooterAlphasDetailsProps {
  handleCheckSubmission: () => void;
  alphaStatus: string;
  handleSubmitAlpha: () => void;
  isAlphaCreatedByTheCurrentUser: boolean;
  fetchingCheck: boolean;
  hasFailedChecks: boolean;
  hasErrors?: boolean;
  isTestPeriodShown: boolean;
  isTestPeriodControlShown: boolean;
}

export const FooterAlphasDetails = ({
  handleCheckSubmission,
  alphaStatus,
  handleSubmitAlpha,
  isAlphaCreatedByTheCurrentUser,
  fetchingCheck,
  hasFailedChecks,
  hasErrors = false,
  isTestPeriodShown,
  isTestPeriodControlShown,
}: //onChangeTestPeriodShown,
FooterAlphasDetailsProps) => {
  const isSubmitDisabled = isTestPeriodControlShown && !isTestPeriodShown;

  const dispatch = useDispatch();
  const handleTestPeriodChange = () => {
    analytics.trackCustomEvent(isTestPeriodShown ? 'sim_click_hide_test_period' : 'sim_click_show_test_period', {
      event_label: 'alpha_page_footer',
    });
    dispatch(setAlphaTestPeriodShown(['alphas', 'alphaDetail'], !isTestPeriodShown));
  };

  return (
    <div className="alphas-details-content__actions">
      {isTestPeriodControlShown && !isTestPeriodShown ? (
        <button className="button button--secondary" onClick={handleTestPeriodChange}>
          {isTestPeriodShown ? (
            <FormattedMessageHelper id="alphaDetails.hideTestPeriod" />
          ) : (
            <FormattedMessageHelper id="alphaDetails.revealTestPeriod" />
          )}
        </button>
      ) : (
        <button
          className="editor-button editor-bottom-bar__bottom-button"
          onClick={handleCheckSubmission}
          disabled={
            fetchingCheck ||
            alphaStatus !== 'UNSUBMITTED' ||
            hasFailedChecks ||
            hasErrors ||
            !isAlphaCreatedByTheCurrentUser ||
            isSubmitDisabled
          }
        >
          <span className="editor-button__text">
            <FormattedMessageHelper
              tagName="span"
              id="editorBottomBarRight.checkSubmission"
              defaultMessage={localeData.en['editorBottomBarRight.checkSubmission']}
            />
          </span>
        </button>
      )}

      <button
        onClick={handleSubmitAlpha}
        disabled={!!(fetchingCheck || alphaStatus !== 'UNSUBMITTED' || hasFailedChecks || isSubmitDisabled || hasErrors)}
        className="intro-step-10 editor-button editor-bottom-bar__bottom-button  editor-bottom-bar__bottom-button--green"
      >
        <span className="editor-button__text">
          <FormattedMessageHelper
            tagName="span"
            id="editorBottomBarRight.submitAlpha"
            defaultMessage={localeData.en['editorBottomBarRight.submitAlpha']}
          />
        </span>
      </button>
    </div>
  );
};
